<template>
  <a-breadcrumb class="breadcrumb">
    <a-breadcrumb-item v-if="breadList[0] && breadList[0].path !== '/'">
      <router-link
        :to="{ path: '/' }"
      >首页</router-link>
    </a-breadcrumb-item>
    <a-breadcrumb-item v-for="(item, index) in breadList" :key="item.name">
      <router-link
        v-if="item.path && item.name != name && index != 1"
        :to="{ path: item.path === '' ? '/' : item.path }"
      >{{ item.title }}</router-link>
      <span v-else>{{ item.title }}</span>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
import menus from '@/core/menus'
export default {
  data () {
    return {
      name: '',
      breadList: []
    }
  },
  created () {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb () {
      this.breadList = []
      this.name = ''
      let menu = this.findMenu(menus, this.$route.path)
      if (menu) {
        this.name = menu[menu.length - 1].title
        this.breadList = menu
      }
    },
    findMenu (menus, path) {
      let rt
      menus.find(menu => {
        if (menu.path === path) {
          rt = [menu]
          return true
        }
        if (menu.children) {
          let childMenu = this.findMenu(menu.children, path)
          if (childMenu) {
            rt = [menu, ...childMenu]
            return true
          }
        }
        return false
      })
      return rt
    }
  },
  watch: {
    $route () {
      this.getBreadcrumb()
    }
  }
}
</script>

<style scoped>
</style>
